import * as React from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "currentColor", viewBox: "0 0 10 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M4.25 9.25v4.25h1.5V9.25H10v-1.5H5.75V3.5h-1.5v4.25H0v1.5z", clipRule: "evenodd" }));
export {
  SvgPlus as default
};
//# sourceMappingURL=plus.js.map
